import {HxApiBrand} from '../../api/erp/info/brand'
import {HxApiStorehouse} from '../../api/erp/info/storehouse'
import {HxApiCategory} from '../../api/erp/info/category'
import {HxApiUnit} from '../../api/erp/info/unit'
import {HxApiSupplier} from '../../api/erp/info/supplier'
import {CommonApi} from '../../request/common_api'
import {ErpApi} from '../../request/Erp/erp_api'

export default {
  async getErpMerchList({state, commit}) {
    if (state.erpMerchList.length) {
      return
    }
    await HxApiBrand.listMerch607001().then(res => {
      commit('setErpMerchList', res.merchList)
    })
  },
  async getBrandList({state, commit}, data) {
    if (state.brandList.length) {
      return
    }
    await HxApiBrand.list602002(data).then(res => {
      commit('setBrandList', res.brandList)
    })
  },
  async getStorehouseList({state, commit}, data) {
    if (state.storehouseList.length) {
      return
    }
    await HxApiStorehouse.storehouseList600002(data).then(res => {
      commit('setStorehouseList', res.storeHouseList)
    })
  },
  async getShelvesList({state, commit}, data) {
    if (state.shelvesList.length) {
      return
    }
    await HxApiStorehouse.shelvesList601002(data).then(res => {
      commit('setShelvesList', res.shelvesList)
    })
  },
  async getSupplierList({state, commit}, data) {
    if (state.supplierList.length) {
      return
    }
    await HxApiSupplier.list605002(data).then(res => {
      commit('setSupplierList', res.supplierList)
    })
  },
  async getCategoryTreeList({state, commit}, data) {
    if (state.categoryTreeList.length) {
      return
    }
    await HxApiCategory.list603002(data).then(res => {
      commit('setCategoryTreeList', res.list)
    })
  },
  async getUnitList({state, commit}, data) {
    if (state.unitList.length) {
      return
    }
    await HxApiUnit.list604002(data).then(res => {
      commit('setUnitList', res.unitList)
    })
  },
  async getExpireList({state, commit}) {
    if (state.expireList.length) {
      return
    }
    await CommonApi.getTableList('EXPIRYTYPE').then(res => {
      if (res.retCode === '0000') {
        commit('setExpireList', res.BizBodyMsg.typeList[0].codeList)
      }
    })
  },
  async getUserStoreHouseList({state, commit}) {
    if (state.userStoreHouseList.length) {
      return
    }
    await ErpApi.getUserStoreHouseList({}).then(res => {
      commit('setUserStoreHouseList', res.codeList)
    })
  },
  async getInStockTypeList({state, commit}) {
    if (state.inStockTypeList.length) {
      return
    }
    await CommonApi.getTableList('GOODSINTYPE').then(res => {
      if (res.retCode === '0000') {
        commit('setInStockTypeList', res.BizBodyMsg.typeList[0].codeList)
      }
    })
  },
  async getOutStockTypeList({state, commit}) {
    if (state.outStockTypeList.length) {
      return
    }
    await CommonApi.getTableList('GOODSOUTTYPE').then(res => {
      if (res.retCode === '0000') {
        commit('setOutStockTypeList', res.BizBodyMsg.typeList[0].codeList)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/erp/actions.js